import { render, staticRenderFns } from "./dayVip.vue?vue&type=template&id=2224d928&scoped=true&"
import script from "./dayVip.vue?vue&type=script&lang=js&"
export * from "./dayVip.vue?vue&type=script&lang=js&"
import style0 from "./dayVip.vue?vue&type=style&index=0&id=2224d928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2224d928",
  null
  
)

export default component.exports